export const ROUTES = {
  home: '/',
  subscribers: '/subscribers',
} as const;
